import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutComponent } from './Shared/layout/layout.component';
import { LayoutLoginComponent } from './Shared/layoutlogin/layoutlogin.component';
import { AppComponent } from './app.component';
import { routModule } from './routing.module';
import { HttpModule } from '@angular/http';
import { CommonService } from './Services/common.service';
import { LoaderService } from './Common/loader.service';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxBarcodeModule } from 'ngx-barcode';
import { MyDatePickerModule } from 'mydatepicker';
import { HttpClientModule } from '@angular/common/http';
import { ipComponent } from './Component/Ip/ipComponent';
import { ExpandableListModule } from 'angular2-expandable-list';
import { AlwaysAuthGuard } from './Common/AlwaysAuthGuard';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxCaptchaModule } from 'ngx-captcha';
import { VersionCheckService } from './Services/version-check.service';
import { ToastrModule } from 'ngx-toastr';
// import { SlimScroll } from 'angular-io-slimscroll';
import { DataTableModule } from "ng2-data-table";
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { Daterangepicker } from 'ng2-daterangepicker';
import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS } from 'ngx-slimscroll';
import { SharedModule } from './Shared/module/shared.module';
import { TranslateService } from './i18n/translate.service';
import { TranslatePipe } from './i18n/translate.pipe';
import { LayoutDashboardComponent } from './Shared/layout-dashboard/layout-dashboard.component';
import { HowItWorksComponent } from './Component/how-it-works/how-it-works.component';
import { GoogleAnalyticService } from './Services/google-analytic.service';
import { AccountDeleteModalComponent } from './Modal/account-delete-modal/account-delete-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
export function setupTranslateFactory(
  service: TranslateService): Function {
  return () => service.use('en');
}


@NgModule({
  declarations: [
    AppComponent,
    ipComponent,
    LayoutComponent,
    LayoutLoginComponent,
    LayoutDashboardComponent,
    AccountDeleteModalComponent
    //TranslatePipe
    //  SlimScroll,
  ],
  imports: [
    BrowserModule, BrowserAnimationsModule,
    HttpModule,
    FormsModule,
    NgxSpinnerModule,
    routModule,
    TooltipModule,
    NgxBarcodeModule,
    MyDatePickerModule,
    HttpClientModule,
    ExpandableListModule,
    ReactiveFormsModule, DataTableModule, Daterangepicker, NgSlimScrollModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    NgxDaterangepickerMd.forRoot(),
    SharedModule,
    NgbModule
  ],
  providers: [CommonService, LoaderService, AlwaysAuthGuard, VersionCheckService, GoogleAnalyticService, {
    provide: SLIMSCROLL_DEFAULTS,
    useValue: {
      alwaysVisible: false
    },
  },
    TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [TranslateService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [AccountDeleteModalComponent]
})
export class AppModule { }
